import { parseJsonTranscript } from "./json";
import { parseMarkdownTranscript } from "./markdown";
import { parseSrtTranscript } from "./srt";
import { parseTxtTranscript } from "./txt";
/**
 * Parse from string given a format.
 * @throws up to 3 zod errors if invalid
 */
export function parseFromString(content, format) {
    try {
        if (format === "json")
            return parseJsonTranscript(content);
        if (format === "md")
            return parseMarkdownTranscript(content);
        if (format === "srt")
            return parseSrtTranscript(content);
        if (format === "txt")
            return parseTxtTranscript(content);
        throw new Error("Unsupported format");
    }
    catch (err) {
        if (typeof err === "object" && err !== null && "errors" in err) {
            const { errors } = err;
            if (Array.isArray(errors)) {
                const msgs = errors.slice(0, 3).map(e => e?.message ?? "Invalid");
                throw new Error(msgs.join("; "));
            }
        }
        if (err instanceof Error) {
            throw err;
        }
        throw new Error("Failed to parse transcript");
    }
}
